/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/TriPeaksLogic/ChallengeAuthorities/PlayValuesDailyTripeaksAuthority',[
    'SolitaireShared/TriPeaksLogic/IDailyTripeaksAuthority',
    'SolitaireShared/CardLogic/IPlayValuesDailyAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/CardOp',
    'SolitaireShared/CardLogic/CardValue'
], function (IDailyTripeaksAuthority, IPlayValuesDailyAuthority, IDailyAuthority, CardOp, CardValue) {
    "use strict";

    var PlayValuesDailyTripeaksAuthority = function (param) {
        this.initPlayValuesDailyTripeaksAuthority(param);
    };

    PlayValuesDailyTripeaksAuthority.Key_NumToPlay = "NUMBERTOPLAY";
    PlayValuesDailyTripeaksAuthority.Key_ValueToPlay = "VALUETOPLAY";

    var TagValueplayed = 0x10000;

    PlayValuesDailyTripeaksAuthority.constructor = PlayValuesDailyTripeaksAuthority;
    PlayValuesDailyTripeaksAuthority.prototype = Object.create(IDailyTripeaksAuthority.prototype);
    IPlayValuesDailyAuthority.call(PlayValuesDailyTripeaksAuthority.prototype);

    PlayValuesDailyTripeaksAuthority.prototype.initPlayValuesDailyTripeaksAuthority = function (param) {
        IDailyTripeaksAuthority.call(this, param);
        this._hasWon = false;
        this.SuppressBonusAnimations = true;

        var isDirty = true;
        if (param != null && param[PlayValuesDailyTripeaksAuthority.Key_NumToPlay] && param[PlayValuesDailyTripeaksAuthority.Key_ValueToPlay])
        {
            isDirty = false;

            this.NumToPlay = parseInt(param[PlayValuesDailyTripeaksAuthority.Key_NumToPlay]);
            this.ValueToPlay = CardValue.getValue(param[PlayValuesDailyTripeaksAuthority.Key_ValueToPlay]);
            this._numPlayed = 0;

            if (isNaN(this.NumToPlay) || !this.ValueToPlay) {
                isDirty = true;
            }

            if (isDirty)
                throw "Invalid parameter passed in creating Daily Challenge";
        }

        this.ChallengeType = IDailyAuthority.ChallengeType.PlayValues;

    };

    Object.defineProperty(PlayValuesDailyTripeaksAuthority.prototype, "Value", {
        get: function () {
            return this.ValueToPlay;
        }
    });

    Object.defineProperty(PlayValuesDailyTripeaksAuthority.prototype, "NumberToPlay", {
        get: function () {
            return this.NumToPlay;
        }
    });

    Object.defineProperty(PlayValuesDailyTripeaksAuthority.prototype, "NumberPlayed", {
        get: function () {
            return this._numPlayed;
        }
    });

    PlayValuesDailyTripeaksAuthority.prototype.Deal = function () {
        if(this.NumDealsLeft() == this.MaxDeals)
            this._numPlayed = 0;

        return IDailyTripeaksAuthority.prototype.Deal.call(this);
    };

    PlayValuesDailyTripeaksAuthority.prototype.GetScoreForAction = function (action)
    {
        for (var i = 0; i < action.Ops.length; i ++)
        {
            var op = action.Ops[i];
            var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
            if (op.Opcode == CardOp.Op.Move
                && destPile.Type == "Waste"
                && op.GetPile(CardOp.eMoveParams.SourcePile).Type != "Stock"
                && destPile.Count > op.GetNumber(CardOp.eMoveParams.NumCards)
                && destPile.NthFromTop(op.GetNumber(CardOp.eMoveParams.NumCards)).Value == this.ValueToPlay)
            {
                action.Tag = (action.Tag | TagValueplayed) >>> 0;
                break;
            }
        }

        return IDailyTripeaksAuthority.prototype.GetScoreForAction.call(this, action);
    };

    PlayValuesDailyTripeaksAuthority.prototype.OnRunSpecialAction = function (tag, undo)
    {
        if (((tag & TagValueplayed) >>> 0) != 0)
        {
            this._numPlayed += (undo ? -1 : 1);
        }

        IDailyTripeaksAuthority.prototype.OnRunSpecialAction.call(this, tag, undo);
    };

    PlayValuesDailyTripeaksAuthority.prototype.IsGameWon = function ()
    {
        if (this.CardSupply.IsWaitingForAds)
        {
            return false;
        }

        if (this.CheckWin() && this._numPlayed < this.NumToPlay && !this.CardSupply.WaitingForAnimation)
            this.Deal();
        return (this._numPlayed >= this.NumToPlay);
    };

    PlayValuesDailyTripeaksAuthority.prototype.GetHint = function (cycle, cheat)
    {
        if(cheat) {
            return IDailyTripeaksAuthority.prototype.GetHint.call(this, cycle, cheat);
        }

        cycle = !!cycle;
        var numTableaus = 28;

        var hints = [];

        var pile;
        var cards = [ "CHALLENGE" ];

        for (var i = numTableaus - 1; i >= 0; i--)
        {
            pile = this.CardSupply.GetPile("Tableau" + i);
            if (pile.Empty)
                continue;

            if (pile.Top.Value == this.ValueToPlay)
            {
                // Note: the actually legal move would be a-to-foundation
                // but the foundation is invisible in Pyramid.

                cards.push(pile.Top.Sequence.toString());
            }
        }

        if (cards.length > 1)
        {
            var hint = new CardOp(this.CardSupply);

            hint.Parse(cards, 0);
            hints.push(hint);
        }

        return hints.length > 0 ? hints[0] : new CardOp(this.CardSupply);
    };

    return PlayValuesDailyTripeaksAuthority;

});
